import axios from 'axios';

const trimTrailingSlash = (value) => (value || '').replace(/\/+$/, '');
const trimLeadingSlash = (value) => (value || '').replace(/^\/+/, '');

const buildUrl = (baseUrl, path = '') => {
  const cleanBaseUrl = trimTrailingSlash(baseUrl);
  const cleanPath = trimLeadingSlash(path);

  return cleanPath ? `${cleanBaseUrl}/${cleanPath}` : cleanBaseUrl;
};

const appBaseUrl = process.env.VUE_APP_URL || 'https://mav-service.wanorn.com/backend/';
const appApiUrl = process.env.VUE_APP_API || buildUrl(appBaseUrl, 'api');
const webApiUrl = process.env.VUE_APP_WEB_API || 'https://webportal.wanorn.com/backend/api/';

export const API_BASE_URL = buildUrl(appApiUrl);
export const APP_BASE_URL = buildUrl(appBaseUrl);
export const WEB_API_BASE_URL = buildUrl(webApiUrl);

const getToken = () => localStorage.getItem('token');

export const createHttpClient = ({ baseURL, useAuth = true } = {}) => {
  const client = axios.create({
    baseURL,
    withCredentials: true,
    maxBodyLength: Infinity,
  });

  client.interceptors.request.use((config) => {
    const token = getToken();

    if (useAuth && token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
      }

      return Promise.reject(error);
    }
  );

  return client;
};

export const apiClient = createHttpClient({ baseURL: API_BASE_URL });
export const appClient = createHttpClient({ baseURL: APP_BASE_URL });
export const webApiClient = createHttpClient({ baseURL: WEB_API_BASE_URL, useAuth: false });

export default apiClient;
